import { render, staticRenderFns } from "./ResponsibleFieldForm.vue?vue&type=template&id=6209469d&"
import script from "./ResponsibleFieldForm.vue?vue&type=script&lang=js&"
export * from "./ResponsibleFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleFieldForm.vue?vue&type=style&index=0&id=6209469d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports